import { gql } from "graphql-request";

export const CREATE_TASK = gql`
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      id
      versionMajor
      versionMinor
      isLatest
      previousVersionTaskId
      rootTaskId
      title
      description
      tenantId
      projectId
      accountableRoleId
      assignedTenantUserId
      status
      sequence
      labels
      dueDate
      deferDate
      cost
      imageUrls
      plannedDurationMin
      actualDurationMin
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      id
      title
      description
      tenantId
      projectId
      accountableRoleId
      assignedTenantUserId
      status
      sequence
      labels
      dueDate
      deferDate
      cost
      imageUrls
      plannedDurationMin
      actualDurationMin
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_TASK_STATUS = gql`
  mutation UpdateTaskStatus($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_TASK = gql`
  mutation DeleteTask($id: ID!) {
    deleteTask(id: $id)
  }
`;

export const RANK_TASK = gql`
  mutation RankTask($input: RankTaskInput!) {
    rankTask(input: $input) {
      id
      sequence
    }
  }
`;

export const MARK_SOP_TASK_READ = gql`
  mutation MarkSOPTaskRead(
    $tenantId: ID!
    $sopId: ID!
    $taskId: ID!
  ) {
    markSOPTaskRead(
      tenantId: $tenantId
      sopId: $sopId
      taskId: $taskId
    ) {
      id
      tenantUserId
      taskId
      taskVersion
      receiptType
      createdAt
    }
  }
`;

export const MARK_SOP_TASK_UNDERSTOOD = gql`
  mutation MarkSOPTaskUnderstood(
    $tenantId: ID!
    $sopId: ID!
    $taskId: ID!
  ) {
    markSOPTaskUnderstood(
      tenantId: $tenantId
      sopId: $sopId
      taskId: $taskId
    ) {
      id
      tenantUserId
      taskId
      taskVersion
      receiptType
      createdAt
    }
  }
`;

export const CREATE_TASK_VERSION = gql`
  mutation CreateTaskVersion($input: CreateTaskVersionInput!) {
    createTaskVersion(input: $input) {
      id
      title
      description
      versionMajor
      versionMinor
      isLatest
      previousVersionTaskId
      rootTaskId
      status
      labels
      projectId
      createdAt
      updatedAt
    }
  }
`;